<template>
	<!-- :title="isEdit ? '编辑债权人' : '添加债权人'" -->
    <el-dialog
        :visible.sync="creditorDialogVisible"
        width="460px"
        center
        v-if="creditorDialogVisible"
        :before-close="cancelDialog"
    >
	<div class="" slot="title" style="text-align: left;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;">
		{{isEdit ? '编辑用户' : '添加用户'}}
	</div>
        <el-form :model="creditorForm" status-icon ref="ruleForm" label-width="120px" class="demo-ruleForm" :rules="rules" label-position="left">
            <el-form-item label="主债务人" prop="debtorName" v-if="isShow">
                <el-input type="text" v-model="creditorForm.debtorName" autocomplete="off" placeholder="请输入主债务人"></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input type="text" v-model="creditorForm.name" autocomplete="off" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="性质" v-if="isType" prop="certificateType">
                <el-select v-model="creditorForm.certificateType" placeholder="请选择">
                    <el-option v-for="item in natureOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="性质" v-else prop="creditorType">
                <el-select v-model="creditorForm.creditorType" placeholder="请选择">
                    <el-option v-for="item in natureOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input type="text" v-model="creditorForm.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
			<el-form-item label="证件号" prop="idNumber">
			    <el-input type="text" v-model="creditorForm.idNumber" autocomplete="off" placeholder="请输入证件号"></el-input>
			</el-form-item>
            <el-form-item label="密码" prop="cypher" v-if="creditorForm.cypher || isEdit">
                <el-input type="text" v-model="creditorForm.cypher" autocomplete="off" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item v-if="isShow" label="代理人姓名" prop="agentName">
                <el-input type="text" v-model="creditorForm.agentName" autocomplete="off" placeholder="请输入代理人姓名"></el-input>
            </el-form-item>
            <el-form-item v-if="isShow" label="代理人手机号" prop="agentPhone">
                <el-input type="text" v-model="creditorForm.agentPhone" autocomplete="off" placeholder="请输入代理人手机号"></el-input>
            </el-form-item>
            <el-form-item v-if="isShow" label="代理人证件号" prop="agentIdNumber">
                <el-input type="text" v-model="creditorForm.agentIdNumber" autocomplete="off" placeholder="请输入代理人证件号"></el-input>
            </el-form-item>
            <el-form-item v-if="isShow" label="代理人密码" prop="agentCypher">
                <el-input type="text" v-model="creditorForm.agentCypher" autocomplete="off" placeholder="请输入代理人密码"></el-input>
            </el-form-item>
            <el-form-item v-if="isShow" label="备注" prop="remark">
                <el-input type="textarea" :rows="3" placeholder="请输入" v-model="creditorForm.remark"> </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
			<!-- type="primary"  -->
            <el-button style="width: 120px;" @click="cancelDialog" plain>取消</el-button>
			<!-- style="background:#de4d2a !important" -->
            <el-button style="width: 120px;" type="primary" @click="addorEditUser('ruleForm')" :loading="loading">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { addCreatorUser, editUser, editMeetingUser } from '@/serve/user';
export default {
    components: {},
    props: {
        creditorDialogVisible: Boolean,
        creditorForm: Object,
        isEdit: Boolean,
        meetingId: String,
        userId: String,
        isType: {
            type: Boolean,
            default: true
        },
        isShow: {
            type: Boolean,
            default: true
        },
        // 判断是哪个菜单下的编辑
        isKey: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let checkPhone = (rule, value, callback) => {
            let reg = /^1[3456789]\d{9}$/;
            if (!reg.test(value)) {
                callback(new Error('请输入11位手机号'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            rules: {
                creditorType: [{ required: true, message: '请选择用户性质', trigger: 'blur' }],
                debtorName: [{ required: true, message: '请填写债务人名称', trigger: 'blur' }],
                name: [{ required: true, message: '请填写用户名称', trigger: 'blur' }],
                // phone: [{ required: true, message: '请填写正确的手机号', validator: checkPhone, trigger: 'blur' }],
                idNumber: [{ required: true, message: '请填写身份证号/社会统一信用代码', trigger: 'blur' }],
                cypher: [{ required: true, message: '请填写密码', trigger: 'blur' }]
            },
            natureOptions: [
                {
                    value: 'PERSON',
                    label: '个人'
                },
                {
                    value: 'COMPANY',
                    label: '企业'
                }
            ]
        };
    },
    methods: {
        // 取消
        cancelDialog() {
            this.$emit('cancel');
        },
        // 调用成功
        callSuccess(flag = false) {
            this.$message.success(flag ? '编辑成功' : '创建成功');
            this.cancelDialog();
            this.$emit('refreshList');
            this.loading = false;
        },
        // 调用失败
        callError(flag = false,message) {
            this.$message.error(flag ? message : message);
            this.loading = false;
            this.cancelDialog();
        },
        // 确定
        addorEditUser(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    // 编辑
                    if (this.isEdit) {
                        if (this.isKey) {
                            editMeetingUser(this.userId, this.meetingId, this.creditorForm)
                                .then(() => {
                                    this.callSuccess(true);
                                })
                                .catch(err => {
                                    this.callError(true,err.data.message);
                                });
                        } else {
                            editUser(this.userId, this.creditorForm)
                                .then(() => {
                                    this.callSuccess(true);
                                })
                                .catch(err => {
                                    this.callError(true,err.data.message);
                                });
                        }
                    } else {
                        // 新增
                        addCreatorUser(this.meetingId, this.creditorForm)
                            .then(() => {
                                this.callSuccess();
                            })
                            .catch(err => {
                                this.$message.error(err.data.message);
                                this.loading = false;
                                this.cancelDialog();
                            });
                    }
                }
            });
        }
    }
};
</script>
